import { timeZoneCityToCountry } from '../data/constants/constants';

type getLocationType = {
    userTimeZone: string;
    userRegion: string;
    userCity: string;
    userCountry: string;
};

export const getLocation = (): getLocationType => {
    if (Intl) {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const tzArr = userTimeZone.split('/');
        const userRegion = tzArr[0];
        const userCity = tzArr[tzArr.length - 1];
        const userCountry = timeZoneCityToCountry[userCity];

        return { userTimeZone, userRegion, userCity, userCountry };
    }

    return { userTimeZone: '', userRegion: '', userCity: '', userCountry: '' };
};
